import { CKButtonBar } from 'clearkit';
import moment from 'moment';

type ActiveIntegrationsTimeRangeFiltersProps = {
  queryStartDate: moment.Moment;
  setQueryStartDate: (arg: moment.Moment) => void;
};
function ActiveIntegrationsTimeRangeFilters({
  queryStartDate,
  setQueryStartDate,
}: ActiveIntegrationsTimeRangeFiltersProps) {
  const timeRanges = [
    { label: 'Last 7 Days', startDate: dateRangeStartDate(-7, 'day') },
    { label: 'Last 14 Days', startDate: dateRangeStartDate(-14, 'day') },
    { label: 'Last 30 Days', startDate: dateRangeStartDate(-30, 'day') },
    { label: 'Last 3 Months', startDate: dateRangeStartDate(-3, 'month') },
    { label: 'Last Year', startDate: dateRangeStartDate(-1, 'year') },
    { label: 'All Time', startDate: dateRangeStartDate(-2, 'year') },
  ];

  return (
    <div className="flex items-center py-2 font-medium min-h-[2.5rem] gap-x-4">
      <div>Show data for:</div>
      <CKButtonBar>
        {timeRanges.map((timePeriod) => {
          const { label, startDate } = timePeriod;
          const isAllTime = label === 'All Time';

          const Button = () => (
            <CKButtonBar.Button
              isSelected={moment(startDate).isSame(queryStartDate, 'day')}
              key={label}
              onClick={() => setQueryStartDate(startDate)}
            >
              {label}
            </CKButtonBar.Button>
          );

          return isAllTime ? (
            <>
              <CKButtonBar.Separator />
              <Button />
            </>
          ) : (
            <Button />
          );
        })}
      </CKButtonBar>
    </div>
  );
}
function dateRangeStartDate(
  amountToAdd: number,
  unit: moment.DurationInputArg2,
) {
  return moment().add(amountToAdd, unit);
}

export default ActiveIntegrationsTimeRangeFilters;
